/**
 *
 * DivisionTable
 *
 */

import React, { Fragment } from "react"
import PropTypes from "prop-types"

import {
  Button,
  Table,
  Input,
  Checkbox,
  Row,
  Divider,
  Tooltip,
  Spin,
  Select,
  message,
} from "antd"

import { Link } from "react-router-dom"
import {
  debounce,
  uniqBy,
  slice,
  get,
  sortBy,
  filter,
  orderBy,
  flatMap,
  includes,
  map,
} from "lodash"
import InfiniteScroll from "react-infinite-scroller"
import TruncateTextTooltip from "components/TruncateTextTooltip"
import arrowBottomSelect from "../../images/varrow.svg"
import alertSvg from "../../images/alert.svg"

import FiltersContainer from "../FiltersContainer"
import ModalCustom from "../ModalCustom"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import plusSvg from "../../images/plus.svg"
import pencilSvg from "../../images/pencil.svg"
import deleteSvg from "../../images/delete.svg"

import AddSubdivisionSelect from "../AddSubdivisionSelect"
import ListSubdivisions from "../ListSubdivisions"
import CreateDivisionModal from "../../containers/CreateDivisionModal"
import CollaboratorsModal from "../CollaboratorsModal"
import RadioButtonDivision from "../RadioButtonDivision"
import {
  CloseCircleOutlined,
  DownloadOutlined,
  DownOutlined,
  LoadingOutlined,
  PlusOutlined,
  SearchOutlined,
  UploadOutlined,
} from "@ant-design/icons"
import "./index.less"
import {
  isModuleBySlug,
  KEY_ORGANIZATION_DIVISIONS_DIVISION_FILTER,
  KEY_ORGANIZATION_DIVISIONS_FILTER,
  KEY_ORGANIZATION_DIVISIONS_LEVEL_FILTER,
  KEY_ORGANIZATION_DIVISIONS_PARENT_FILTER,
  KEY_ORGANIZATION_DIVISIONS_TEXT_FILTER,
  LOCAL_ORGANIZATION_DIVISIONS_DIVISION_FILTER,
  LOCAL_ORGANIZATION_DIVISIONS_FILTER,
  LOCAL_ORGANIZATION_DIVISIONS_LEVEL_FILTER,
  LOCAL_ORGANIZATION_DIVISIONS_PARENT_FILTER,
  LOCAL_ORGANIZATION_DIVISIONS_TEXT_FILTER,
  setItem,
  LOCAL_USER_ID,
  LOCAL_VISMA_PEOPLE_SYNC_ENABLED,
} from "../../utils/storage"
import { AMBASSADOR_USERS } from "../../utils/constants"
import { buttonAction_btns, buttonAction_s } from "../Snowplow/config2"
import { withRouter } from "react-router-dom"

const CheckboxGroup = Checkbox.Group
const { Option } = Select
let data_button_colaborator = {
  category: window.location.hash
    ? window.location.hash
    : window.location.pathname,
  action: "Abrir modal colaboradores",
  label: "Click a n colaboradores",
  property: "number",
  value: LOCAL_USER_ID(),
}
const buttonAction_colaborator = () => {
  buttonAction_s(data_button_colaborator)
}

/* eslint-disable react/prefer-stateless-function */
class DivisionTable extends React.Component {
  state = {
    isLoadingState: true,
    size: "large",
    selectedDivisionSuperiorItems: JSON.parse(
      LOCAL_ORGANIZATION_DIVISIONS_PARENT_FILTER()
    ),
    selectedDivisionItems: JSON.parse(
      LOCAL_ORGANIZATION_DIVISIONS_DIVISION_FILTER()
    ),
    per_page: 15,
    page: 1,
    searchfilter: LOCAL_ORGANIZATION_DIVISIONS_TEXT_FILTER(),
    filters: [],
    parentFilters: [],
    levelFilters: [],
    textDivisionSuperior: "",
    textDivision: "",
    hasMoreItems: true,
    hasMoreDivisionSuperiorItems: true,
    isLoadingListFilter: false,
    isLoadingListSuperiorFilter: false,
    divModal: false,
    subModal: false,
    showModalSelectDivisionSuperior: false,
    divisionSuperiorSelected: {},
    idParentSelected: undefined,
    divisionsSelected: undefined,
    modalSubdivisionSelected: false,
    modalDeleteDivision: false,
    subdivisionSelected: {},
    valueOptionSelected: undefined,
    isRemovingSubdivision: false,
    openCollaboratorsModal: false,
    tagFilters: [],
    levelSelecteds: JSON.parse(LOCAL_ORGANIZATION_DIVISIONS_LEVEL_FILTER()),
    orderBySubdivisions: true,
    openColumnSelect: false,
    columnsSelected: JSON.parse(LOCAL_ORGANIZATION_DIVISIONS_FILTER()),
    mainSearchValue: LOCAL_ORGANIZATION_DIVISIONS_TEXT_FILTER(),
    indexTable: 1,
    paginationRecord: {
      current: 1,
      pageSize: 15,
      sortField: 'level',
      sortOrder: 'asc'
    }
  }

  onChange = (checkedList) => {
    this.setState({ checkedList })
  }

  UNSAFE_componentWillMount = () => {
    document.addEventListener(
      "click",
      (e) => {
        if (
          this.state.openColumnSelect &&
          this.wrapperRefCheckbox &&
          !this.wrapperRefCheckbox.contains(e.target) &&
          e.target &&
          !e.target.closest(".ant-select-dropdown")
        ) {
          this.setState({ openColumnSelect: false })
        }
      },
      false
    )
  }

  componentDidMount = () => {
    this.getDivisions(this.state.searchfilter)
  }

  componentWillUnmount = () => {
    setItem(KEY_ORGANIZATION_DIVISIONS_DIVISION_FILTER, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_DIVISIONS_PARENT_FILTER, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_DIVISIONS_LEVEL_FILTER, JSON.stringify([]))
    setItem(KEY_ORGANIZATION_DIVISIONS_TEXT_FILTER, "")
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (Array.isArray(nextProps.data)) {
      setTimeout(() => {
        this.setState({ isLoadingState: false })
       // this.okClickOutside()
      }, 5000)
    }
  }

  handleChange = (e) => {
    this.setState({ per_page: e }, () => {
      this.getDivisions()
    })
  }

  handleSearch = (value) => {
    this.setState({ searchfilter: value }, () => {
      setItem(KEY_ORGANIZATION_DIVISIONS_TEXT_FILTER, this.state.searchfilter)
      this.getDivisions(this.state.searchfilter)
    })
  }

  changeSelectOptionSubdivision = (name, value) => {
    this.setState({ [name]: value })
  }

  searchWithDebounce = debounce(this.handleSearch, 500)

  handleFilter = (selectedKeys, confirm) => {
    confirm()
  }

  onChangePage = (page, pageSize) => {
    this.setState({ page }, () => {
      this.getDivisions()
    })
  }

  getDivisions = (filter) => {
    
    if (filter) {
      const params = {
        table: true,
        "filter[searchByDivisionName]": this.state.searchfilter,
        divisions: this.state.selectedDivisionItems,
        divisions_parent: this.state.selectedDivisionSuperiorItems,
        levels: this.state.levelSelecteds,
      }

      const payload = { params }
      this.props.getDivisions(payload)
    } else {
      const params = {
        table: true, divisions: this.state.selectedDivisionItems,
        "filter[searchByDivisionName]": this.state.searchfilter,
        divisions_parent: this.state.selectedDivisionSuperiorItems,
        levels: this.state.levelSelecteds
      }
      const payload = { params }
      this.props.getDivisions(payload)
    }
  }

  filterDivisionDebounce = (value) => {
    if (!value) {
      return this.setState({
        filters: slice(this.props.divisionsFilter, 0, 100),
        isLoadingListFilter: false,
        hasMoreItems: true,
      })
    }
    this.setState({
      filters: this.props.divisionsFilter.filter((item) =>
        item.division.toLowerCase().includes(value.toLowerCase())
      ),
      isLoadingListFilter: false,
    })
  }

  filterDivisionSuperiorDebounce = (value) => {
    
    if (!value) {
      return this.setState({
        parentFilters: slice(
          orderBy(this.props.divisionsParentFilter, "division_parent_name"),
          0,
          100
        ),
        isLoadingListSuperiorFilter: false,
        hasMoreDivisionSuperiorItems: true,
      })
    }

    const filteredItems = this.props.divisionsParentFilter.filter((item) => {
      const divisionName = item.division_parent_name ? item.division_parent_name.toLowerCase() : '';
      const searchValue = value.toLowerCase();
      const includesValue = divisionName.includes(searchValue);
      return includesValue;
    });
    this.setState({
      parentFilters: orderBy(filteredItems, "division_parent_name"),
      isLoadingListSuperiorFilter: false,
    }, () => {
     
    });
  }

  searchDivisionWithDebounce = debounce(this.filterDivisionDebounce, 500)
  searchDivisionSuperWithDebounce = debounce(
    this.filterDivisionSuperiorDebounce,
    500
  )

  onDivisionFilter = (e) => {
    this.setState(
      {
        textDivision: e.target.value,
        isLoadingListFilter: true,
        hasMoreItems: false,
      },
      () => this.searchDivisionWithDebounce(this.state.textDivision)
    )
  }

  onDivisionSuperiorFilter = (e) => {
    this.setState(
      {
        textDivisionSuperior: e.target.value,
        isLoadingListSuperiorFilter: true,
        hasMoreDivisionSuperiorItems: false,
      },
      () =>
        this.searchDivisionSuperWithDebounce(this.state.textDivisionSuperior)
    )
  }

  showTotal = (total, range) => (
    <span
      style={{
        marginRigth: "auto",
        color: "#A6A6A6",
      }}>{`Total divisiones: ${total}`}</span>
  )

  loadMoreDataDivisionSuperior = () => {
    this.setState((prevState) => {
      if (this.props.divisionsParentFilter.length <= prevState.parentFilters.length) {
        return this.setState({ hasMoreDivisionSuperiorItems: false })
      }

      return {
        parentFilters: [
          ...prevState.parentFilters,
          ...slice(
            this.props.divisionsParentFilter,
            prevState.parentFilters.length,
            prevState.parentFilters.length + 100
          ),
        ],
      }
    })
  }

  valueOfSelectAddSubdivision = null

  showAlertDeleteSubdivision = () => {
    setTimeout(() => {
      if (this.props.messageDeleteSubdivision) {
        message.success(
          <span>
            {this.props.messageDeleteSubdivision.msj}{" "}
            <span
              style={{ color: "#2694FC", cursor: "pointer", marginLeft: 6 }}
              onClick={() => {
                this.props.addSubdivisionTable(this.valueOfSelectAddSubdivision)
                message.destroy()
              }}>
              Deshacer
            </span>
          </span>,
          5
        )
      }
      this.setState({ isRemovingSubdivision: false })
    }, 1500)
  }

  confirmDivisionSuperior = null

  divisionSuperiorDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    buttonAction_btns("Filtro de columna División superior")
    this.confirmDivisionSuperior = confirm
    return (
      <div className="custom-filter-dropdown">
        <Input
          ref={(ele) => (this.searchInput = ele)}
          placeholder="Buscar..."
          style={{ width: "200px" }}
          value={this.state.textDivisionSuperior}
          onChange={this.onDivisionSuperiorFilter}
        />
        <div className="selectList">
          <CheckboxGroup
            value={this.state.selectedDivisionSuperiorItems}
            style={{ width: "100%" }}
            onChange={(selected) => {
              this.setState({ selectedDivisionSuperiorItems: selected })
              setSelectedKeys([...selected])
              
            }}>
            <Spin
              size="large"
              className="spinListFilter"
              spinning={this.state.isLoadingListSuperiorFilter}>
              <div
                style={{
                  maxHeight: 180,
                  overflow: "auto",
                  width: "100%",
                  backgroundColor: "#FFF",
                }}>
                <InfiniteScroll
                  pageStart={0}
                  loadMore={() => {
                    // if (!this.state.textDivisionSuperior) {
                    //   this.loadMoreDataDivisionSuperior()
                    // }
                  }}
                  loader={null}
                  hasMore={
                    this.state.hasMoreDivisionSuperiorItems &&
                    !this.state.textDivisionSuperior
                  }
                  useWindow={false}>
                  {/* ADDING FILTER FOR COMPANY */}
                  {/* { orderBy(uniqBy(filter(this.state.parentFilters, item => item.level !== 1), 'parentdivision.name'), 'parentdivision.name').map((division, index) => { */}
                  {orderBy(
                    this.state.parentFilters,
                    [(d) => d.division_parent_name ? d.division_parent_name.toLowerCase() : ''],
                    ['asc']
                  ).map((div, index) => {
                    if (!div.division_parent_name) return
                    return (
                      <Row key={div.id_division}>
                        <Checkbox
                          value={div.division_parent_name}
                          style={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            maxWidth: "200px",
                          }}>
                          <span>{div.division_parent_name}</span>
                        </Checkbox>
                      </Row>
                    )
                  })}
                </InfiniteScroll>
              </div>
            </Spin>
          </CheckboxGroup>
        </div>
        <Divider />
        <div className="customFilterActions">
          <span
            onClick={() => {
              setSelectedKeys(this.state.selectedDivisionSuperiorItems)
              if (!this.state.selectedDivisionSuperiorItems.length) {
                setSelectedKeys([])
              }
              this.onOkFilter(confirm)
              this.setState({
                textDivisionSuperior: "",
                parentFilters: slice(
                  orderBy(this.props.divisionsParentFilter, "division_parent_name"),
                  0,
                  100
                ),
              })
            }}>
            Ok
          </span>
          <span
            onClick={() => {
              clearFilters()
              setSelectedKeys([])
              this.searchInput = ""
              this.setState(
                {
                  selectedDivisionSuperiorItems: [],
                  textDivisionSuperior: "",
                  parentFilters: orderBy(this.props.divisionsParentFilter, "division_parent_name"),
                  tagFilters: this.state.selectedDivisionItems.concat(
                    this.state.levelSelecteds
                  ),
                },
                () => {
                  setItem(
                    KEY_ORGANIZATION_DIVISIONS_PARENT_FILTER,
                    JSON.stringify([])
                  )
                  confirm()
                }
              )
            }}>
            Reiniciar
          </span>
        </div>
      </div>
    )
  }

  loadMoreDataDivision = () => {
    this.setState((prevState) => {
      if (this.props.divisionsFilter.length <= prevState.filters.length) {
        return { hasMoreItems: false }
      }

      return {
        filters: [
          ...prevState.filters,
          ...slice(
            this.props.divisionsFilter,
            prevState.filters.length,
            prevState.filters.length + 100
          ),
        ],
      }
    })
  }

  onOkFilter = (confirm) => {
    this.setState(
      {
        tagFilters: this.state.selectedDivisionSuperiorItems.concat(
          this.state.selectedDivisionItems,
          this.state.levelSelecteds
        ),
      },
      () => {
        setItem(
          KEY_ORGANIZATION_DIVISIONS_DIVISION_FILTER,
          JSON.stringify(this.state.selectedDivisionItems)
        )
        setItem(
          KEY_ORGANIZATION_DIVISIONS_PARENT_FILTER,
          JSON.stringify(this.state.selectedDivisionSuperiorItems)
        )
        setItem(
          KEY_ORGANIZATION_DIVISIONS_LEVEL_FILTER,
          JSON.stringify(this.state.levelSelecteds)
        )
        confirm()
      }
    )
  }

 okClickOutside = () => {
    this.setState({
      tagFilters: this.state.selectedDivisionSuperiorItems.concat(
        this.state.selectedDivisionItems,
        this.state.levelSelecteds
      ),
    })
  } 

  divisionDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }) => {
    return (
      <div className="custom-filter-dropdown">
        <Input
          ref={(ele) => (this.searchInput = ele)}
          placeholder="Buscar..."
          style={{ width: "200px" }}
          value={this.state.textDivision}
          onChange={this.onDivisionFilter}
        />
        <Spin
          size="large"
          className="spinListFilter"
          spinning={this.state.isLoadingListFilter}>
          <div className="selectList">
            <CheckboxGroup
              value={this.state.selectedDivisionItems}
              style={{ width: "100%" }}
              onChange={(selected) => {
                this.setState({ selectedDivisionItems: selected })
                setSelectedKeys([selected])
                
              }}>
              <div
                style={{
                  maxHeight: 180,
                  overflow: "auto",
                  width: "100%",
                  backgroundColor: "#FFF",
                }}>
                <InfiniteScroll
                  pageStart={0}
                  loadMore={() => {
                    if (!this.state.textDivision) {
                      this.loadMoreDataDivision()
                    }
                  }}
                  loader={<div key={0}>Loading ...</div>}
                  hasMore={this.state.hasMoreItems && !this.state.textDivision}
                  useWindow={false}>
                  {orderBy(
                    this.state.filters,
                    [(d) => d.division ? d.division.toLowerCase() : ''],
                    ['asc']
                  ).map((div) => {
                    return (
                      <Row key={div.id_division}>
                        <Checkbox
                          value={div.division}
                          style={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            maxWidth: "200px",
                          }}>
                          <span>{div.division}</span>
                        </Checkbox>
                      </Row>
                    )
                  })}
                </InfiniteScroll>
              </div>
            </CheckboxGroup>
          </div>
        </Spin>
        <Divider />
        <div className="customFilterActions">
          <span
            onClick={() => {
              setSelectedKeys(this.state.selectedDivisionItems)
              if (!this.state.selectedDivisionItems.length) {
                clearFilters()
              }
              this.setState({
                textDivision: "",
                filters: slice(this.props.divisionsFilter, 0, 100),
              })
              this.onOkFilter(confirm)
            }}>
            Ok
          </span>
          <span
            onClick={() => {
              clearFilters()
              this.setState(
                {
                  selectedDivisionItems: [],
                  textDivision: "",
                  hasMoreItems: true,
                  filters: slice(this.props.divisionsFilter, 0, 100),
                  tagFilters: this.state.selectedDivisionSuperiorItems.concat(
                    this.state.levelSelecteds
                  ),
                },
                () => {
                  setItem(
                    KEY_ORGANIZATION_DIVISIONS_DIVISION_FILTER,
                    JSON.stringify([])
                  )
                  confirm()
                }
              )
              setSelectedKeys([])
            }}>
            Reiniciar
          </span>
        </div>
      </div>
    )
  }

  onFilterDropVisibleChange = (name, visible) => {
    if (name === "divisionSuperior" && visible) {
      if (!this.state.selectedDivisionItems.length) {
        return this.setState({
          textDivisionSuperior: "",
          parentFilters: slice(
            orderBy(
              this.props.divisionsParentFilter,
              "division_parent_name"
            ),
            0,
            100
          ),
        })
      }
      this.setState({
        // parentFilters: slice(orderBy(uniqBy(this.props.data, 'parentdivision.name'), 'parentdivision.name'), 0, 100),
        parentFilters: orderBy(this.props.divisionsParentFilter, "division_parent_name"),
        textDivisionSuperior: "",
      })
    }

    if (name === "division" && visible) {
      this.setState({
        filters: slice(orderBy(this.props.divisionsFilter, "division"), 0, 100),
        textDivision: "",
      })
    }

    if (name === "levelFilters" && visible) {
      if (
        this.state.selectedDivisionItems.length ||
        this.state.selectedDivisionSuperiorItems.length
      ) {
        return this.setState({
          levelFilters: orderBy(this.props.levelFilter, "level")
        })
      }

      this.setState({ levelFilters: orderBy(this.props.levelFilter, "level") })
    }

    if (name === "division" && !visible) {
      this.setState({
        filters: slice(orderBy(this.props.divisionsFilter, "division"), 0, 100),
        textDivision: "",
      })
    }

    if (visible) {
      setTimeout(() => {
        this.searchInput.focus()
      })
    }
   // this.okClickOutside()
  }

  removeFilter = (itemRemoved) => {
    return new Promise((resolve) => {
      if (itemRemoved === "delete-all") {
        return this.setState(
          {
            selectedDivisionItems: [],
            selectedDivisionSuperiorItems: [],
            levelSelecteds: [],
            indexTable: this.state.indexTable + 1,
          },
          () => {
            this.okClickOutside();
            resolve();
          }
        );
      }
  
      if (this.state.selectedDivisionItems.includes(itemRemoved)) {
        return this.setState(
          {
            selectedDivisionItems: this.state.selectedDivisionItems.filter(
              (item) => item !== itemRemoved
            ),
            indexTable: this.state.indexTable + 1,
          },
          () => {
            this.okClickOutside();
            resolve();
          }
        );
      }
  
      if (this.state.selectedDivisionSuperiorItems.includes(itemRemoved)) {
        return this.setState(
          {
            selectedDivisionSuperiorItems: this.state.selectedDivisionSuperiorItems.filter(
              (item) => item !== itemRemoved
            ),
            indexTable: this.state.indexTable + 1,
          },
          () => {
            this.okClickOutside();
            resolve();
          }
        );
      }
  
      if (this.state.levelSelecteds.includes(itemRemoved)) {
        return this.setState(
          {
            levelSelecteds: this.state.levelSelecteds.filter(
              (item) => item !== itemRemoved
            ),
            indexTable: this.state.indexTable + 1,
          },
          () => {
            this.okClickOutside();
            resolve();
          }
        );
      }
  
      // En caso no esté en ningún array
      resolve();
    });
  };
  

  levelDropdown = ({
    clearFilters,
    setSelectedKeys,
    selectedKeys,
    confirm,
  }) => {
    return (
      <div className="custom-filter-dropdown">
        <Spin
          size="large"
          className="spinListFilter"
          spinning={this.state.isLoadingListFilter}>
          <div className="selectList">
            <CheckboxGroup
              value={this.state.levelSelecteds}
              style={{ width: "100%" }}
              onChange={(selected) => {
                this.setState({ levelSelecteds: selected })
                setSelectedKeys(selected)
                
              }}>
              <div
                style={{
                  overflow: "auto",
                  backgroundColor: "#FFF",
                  width: 94,
                }}>
                {orderBy(this.state.levelFilters, "level").map((division) => {
                  return (
                    <Row key={division.level}>
                      <Checkbox
                        value={division.level}
                        style={{
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          maxWidth: "200px",
                        }}>
                        <span>{division.level}</span>
                      </Checkbox>
                    </Row>
                  )
                })}
              </div>
            </CheckboxGroup>
          </div>
        </Spin>
        <Divider />
        <div className="customFilterActions">
          <span
            onClick={() => {
              setSelectedKeys(this.state.levelSelecteds)
              this.onOkFilter(confirm)
            }}>
            Ok
          </span>
          <span
            onClick={() => {
              this.setState({ 
                levelSelecteds: [],
                tagFilters: this.state.selectedDivisionSuperiorItems.concat(
                  this.state.selectedDivisionItems
                ),
              }, () => {
                setItem(
                  KEY_ORGANIZATION_DIVISIONS_LEVEL_FILTER,
                  JSON.stringify([])
                )
                confirm()
              })
              setSelectedKeys([])
              clearFilters()
            }}>
            Reiniciar
          </span>
        </div>
      </div>
    )
  }

  clickCheckboxs = (e) => {
    setItem(KEY_ORGANIZATION_DIVISIONS_FILTER, JSON.stringify(e))
    this.setState({ columnsSelected: e })
  }


  showCellButtons = (record) => {
    const cellContent = () => {
      return (
        <div className="divisionCellIcons">
          <Link to={`/organization/division/edit/${record.id_division}`}>
            <Button className="buttonsTable editButtonGray">
              <img src={pencilSvg} />
            </Button>
          </Link>
          <Button
            className="buttonsTable deleteButtonGray"
            onClick={() => {
              this.setState({
                divisionsSelected: record,
                modalDeleteDivision: true,
              })
            }}>
            <img src={deleteSvg} />
          </Button>
        </div>
      )
    }

    if(!LOCAL_VISMA_PEOPLE_SYNC_ENABLED()) {
      return cellContent()
    }

    if(record.division.toLowerCase() !== 'sin asignar') {
      return cellContent()
    }

    return <></>
  }

  render() {
    const handleTableChange = (pagination, filters, sorter) => {
      let sortField = '';
      let sortOrder = '';

      if (sorter.column && sorter.column.sorter === true) {
        sortField = sorter.field ? sorter.field : sorter.columnKey;
        sortOrder = sorter.order ? (sorter.order === 'ascend' ? 'asc' : 'desc') : '';

        if (sortField === 'employees') {
          buttonAction_btns(
            "Ordenar ascendente/descendente la columna Colaboradores"
          )
        }
        if (sortField === 'level') {
          buttonAction_btns("Ordenar ascendente/descendente la columna Nivel")
        }
      }


      let data = {
        page: pagination.current,
        perPage: pagination.pageSize,
        "filter[searchByDivisionName]": this.state.searchfilter,
        sortField: sortField,
        sortOrder: sortOrder,
        divisions: this.state.selectedDivisionItems,
        divisions_parent: this.state.selectedDivisionSuperiorItems,
        levels: this.state.levelSelecteds,
        table: true,
      }
      this.setState({ paginationRecord: data })
      const payload = { params: data }
      this.props.getDivisions(payload)
    };
    const columns = [
      {
        title: "División",
        dataIndex: "division",
        width: 380,
        key: "division",

        defaultFilteredValue: this.state.selectedDivisionItems,
        sorter: true,
        filterDropdown: this.divisionDropdown,
        onFilterDropdownVisibleChange: (visible) =>
          this.onFilterDropVisibleChange("division", visible),
        onFilter: (value, record) => {
          if (value.length < 1) {
            return record.division.includes(value)
          }
          return value.includes(record.division)
        },
        render: (item, record) => {
          return (
            <div className="divisionCellC">
              <span>
                <TruncateTextTooltip title={item} />
              </span>
              {this.showCellButtons(record)}
            </div>
          )
        },
      },
      {
        title: "División superior",
        width: 350,
        dataIndex: "parentdivision",
        key: "parentdivision",
        defaultFilteredValue: this.state.selectedDivisionSuperiorItems,
        sorter: true,
        filterDropdown: this.divisionSuperiorDropdown,
        onFilterDropdownVisibleChange: (visible) =>
          this.onFilterDropVisibleChange("divisionSuperior", visible),
        onFilter: (value, record) => {
          if (value.length < 1) {
            return record.division_parent_name.includes(value)
          }
          return value.includes(record.division_parent_name)
        },
        render: (item, record) => {
          if (item.autoassigned) {
            return (
              <span
                style={{
                  color: "#378FEE",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => {
                  this.setState({
                    showModalSelectDivisionSuperior: true,
                    divisionSuperiorSelected: record,
                  })
                  this.props.getDivisionParents(record.id_division)
                }}>
                Seleccionar
              </span>
            )
          }
          if (item.html) {
            return (
              <strong style={{ fontWeight: 600 }}>
                <TruncateTextTooltip title={item.name} />
              </strong>
            )
          }

          return (
            <div>
              <TruncateTextTooltip title={item.name} />
            </div>
          )
        },
      },
      {
        title: "Colaboradores",
        width: 176,
        dataIndex: "employees",
        key: "employees",
        sorter: true,
        render: (text, record) => {
          const antIcon = (
            <LoadingOutlined style={{ fontSize: 24, color: "#FFF" }} />
          )

          const tooltipText = () => {
            if (this.props.isLoadingCollaboratorsTable)
              return <Spin size="large" indicator={antIcon} />

            return (
              <div style={{ display: "flex", flexDirection: "column" }}>
                {slice(
                  get(this.props.collaboratorsTable, "data", []),
                  0,
                  5
                ).map((item, index) => {
                  return (
                    <span key={index}>
                      {index + 1}. {item.first_name} {item.last_name}
                    </span>
                  )
                })}
                {get(this.props.collaboratorsTable, "data", []).length > 5 && (
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.setState({ openCollaboratorsModal: true })
                      buttonAction_colaborator
                      // this.props.getDivisionsUnassigned(record.id_division)
                    }}>
                    Ver más
                  </span>
                )}
              </div>
            )
          }

          return (
            <div>
              {!text ? (
                <span>{text}</span>
              ) : (
                <Tooltip placement="top" title={tooltipText}>
                  <span
                    style={{
                      width: 28,
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      buttonAction_btns("Número de Colaboradores")
                      this.setState({ openCollaboratorsModal: true })
                    }}
                    onMouseOver={() => {
                      this.props.getCollaboratorsTable(record.id_division)
                      this.setState({ divisionsSelected: record })
                    }}>
                    {text}
                  </span>
                </Tooltip>
              )}
            </div>
          )
        },
      },
      {
        title: "Nivel",
        width: 120,
        key: "level",
        dataIndex: "level",
        defaultFilteredValue: this.state.levelSelecteds,
        filterDropdown: this.levelDropdown,
        onFilterDropdownVisibleChange: (visible) =>
          this.onFilterDropVisibleChange("levelFilters", visible),
        sorter: true,
        onFilter: (value, record) => {
          if (value.length < 1) {
            return record.level.includes(value)
          }
          return [value].includes(record.level)
        },
        render: (text) => {
          return <span>{text}</span>
        },
      },
      {
        title: "Subdivisiones",
        dataIndex: "subdivisions",
        width: 169,
        key: "subs",
        sorter: true,
        render: (text, record) => {
          const antIcon = (
            <LoadingOutlined style={{ fontSize: 24, color: "#FFF" }} />
          )

          const tooltipText = () => {
            if (this.props.isLoadingSubdivisionsTable)
              return <Spin size="large" indicator={antIcon} />

            return (
              <div style={{ display: "flex", flexDirection: "column" }}>
                {slice(get(this.props.subdivisionsTable, "data", []), 0, 5).map(
                  (item, index) => {
                    return (
                      <span key={index}>
                        {index + 1}. {item.name}
                      </span>
                    )
                  }
                )}
                {get(this.props.subdivisionsTable, "data", []).length > 5 && (
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.setState({
                        modalSubdivisionSelected: true,
                        subdivisionSelected: record,
                      })
                      this.props.getDivisionsUnassigned(record.id_division)
                    }}>
                    Ver más
                  </span>
                )}
              </div>
            )
          }

          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              {!text ? (
                <span style={{ width: 28 }}>{text}</span>
              ) : (
                <Tooltip placement="top" title={tooltipText}>
                  <span
                    style={{
                      width: 28,
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      this.setState({
                        modalSubdivisionSelected: true,
                        subdivisionSelected: record,
                      })
                      this.props.getDivisionsUnassigned(record.id_division)
                      this.props.getSubdivisionsTable(record.id_division)
                    }}
                    onMouseOver={() => {
                      this.props.getSubdivisionsTable(record.id_division)
                    }}>
                    {text}
                  </span>
                </Tooltip>
              )}
              <Button
                className="buttonsTable plusGreenTable"
                onClick={() => {
                  this.setState({
                    modalSubdivisionSelected: true,
                    subdivisionSelected: record,
                  })
                  this.props.getDivisionsUnassigned(record.id_division)
                  this.props.getSubdivisionsTable(record.id_division)
                }}>
                <img src={plusSvg} />
              </Button>
            </div>
          )
        },
      },
    ]
    const isAmbassador = isModuleBySlug(AMBASSADOR_USERS)
    if (isAmbassador && includes(this.state.columnsSelected, "ambassadors")) {
      columns.push({
        title: "Embajadores",
        dataIndex: "ambassadors",
        width: 220,
        key: "ambassadors",
        render: (text, record) => {
          if (!text.length) return "-"

          const separate = flatMap(
            text,
            (item) => `${item.first_name} ${item.last_name}`
          )
            .slice(0, 1)
            .join(", ")
          const rest = flatMap(
            text,
            (item) => `${item.first_name} ${item.last_name}`
          ).slice(1, text.length)
          const tooltipText = () => {
            return (
              <div
                className="collaborators-team-tooltip"
                style={{ maxHeight: 100, overflow: "auto" }}>
                {map(rest, (item, index) => {
                  return <span key={index}>{item}</span>
                })}
              </div>
            )
          }
          return (
            <Fragment>
              <span
                className="string_dots"
                style={{
                  display: "inline-block",
                  maxWidth: text.length > 1 ? "80%" : "100%",
                }}>
                {separate}
              </span>
              {text.length > 1 ? (
                <Fragment>
                  <span
                    style={{ display: "inline-block", verticalAlign: "top" }}>
                    ,{" "}
                  </span>{" "}
                  <Tooltip placement="top" title={tooltipText}>
                    <span
                      style={{ display: "inline-block", verticalAlign: "top" }}
                      className="hover-underline">
                      {" "}
                      +{text.length - 1}
                    </span>
                  </Tooltip>
                </Fragment>
              ) : null}
            </Fragment>
          )
        },
      })
    }
    const SearchIcon = this.state.searchfilter ? (
      <CloseCircleOutlined
        style={{
          cursor: "pointer",
          color: "white",
          background: "rgba(0, 0, 0, 0.25)",
          borderRadius: "50%",
        }}
        onClick={() => {
          this.searchWithDebounce("")
          this.setState({ mainSearchValue: "" })
        }}
      />
    ) : (
      <SearchOutlined style={{ color: '#A7A3A3' }}/>
    )
    // snowplow
    let data_button_column = {
      category: window.location.hash
        ? window.location.hash
        : window.location.pathname,
      action: "Columnas",
      label: "Click a columnas",
      property: "select",
      value: LOCAL_USER_ID(),
    }
    let data_button_search = {
      category: window.location.hash
        ? window.location.hash
        : window.location.pathname,
      action: "Buscar",
      label: "Click a buscar",
      property: "input",
      value: LOCAL_USER_ID(),
    }
    const hasFreshchat =
    typeof window.Intercom !== "undefined" &&
    window.self === window.top;
    return (
      <div className="DivisionTableContainer">
        <div className="divisionsHeader">
          <RadioButtonDivision
            tableView={this.props.tableView}
            toggleTableView={this.props.toggleTableView}
            toggleModal={this.props.toggleModal}
            rows={get(this.props.rowSelection, "selectedRowKeys", [])}
          />
          <FiltersContainer
            removeFilter={this.removeFilter}
            filters={this.state.tagFilters}
            getDivisions={this.getDivisions}
          />
          <div className="dHFilters">
            {isAmbassador && (
              <div
                ref={(ele) => {
                  this.wrapperRefCheckbox = ele
                }}>
                <CheckboxGroup
                  value={this.state.columnsSelected}
                  onChange={this.clickCheckboxs}
                  style={{ position: "relative" }}>
                  <DownOutlined
                    className="arrow-down-select"
                    onClick={() =>
                      this.setState({
                        openColumnSelect: !this.state.openColumnSelect,
                      })
                    }
                  />
                  <Select
                    value={[]}
                    onFocus={() => this.setState({ openColumnSelect: true })}
                    onBlur={() =>
                      this.setState(
                        { openColumnSelect: false },
                        buttonAction_s(data_button_column)
                      )
                    }
                    open={this.state.openColumnSelect}
                    mode="multiple"
                    style={{ width: 160 }}
                    placeholder="Columnas">
                    <Option value="Embajadores">
                      <Checkbox value="ambassadors">Embajadores</Checkbox>
                    </Option>
                  </Select>
                </CheckboxGroup>
              </div>
            )}

            <Input
              value={this.state.mainSearchValue}
              suffix={SearchIcon}
              placeholder="Buscar..."
              onChange={(e) => {
                this.searchWithDebounce(e.target.value)
                this.setState({ mainSearchValue: e.target.value })
                buttonAction_s(data_button_search)
              }}
              style={{ width: 280 }}
            />
            {this.props.hasDivisions && (
                <div className="buttonsDivisions">
                  <Button
                    type="primary"
                    className="removeTableButton"
                    style={{
                      display: this.props.buttonDeleteDivisions
                        ? "flex"
                        : "none",
                    }}
                    onClick={() =>
                      this.props.toggleModal("modalDeleteDivisions", true)
                    }>
                    <img src={deleteSvg} />
                    Eliminar
                  </Button>
                  <Tooltip placement="top" title="Crear división">
                    <Button
                      className="blueButton createDivisionButton"
                      size="default"
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        woopraTrack("Crear división")
                        this.props.toggleCreateModal(true)
                      }}
                    />
                  </Tooltip>
                  <Tooltip placement="top" title="Importar divisiones">
                    <Button
                      className="whiteButton"
                      size="default"
                      icon={<UploadOutlined />}
                      onClick={() => {
                        woopraTrack("Importar divisiones")
                        this.props.history.push(
                          "/organization/divisions/import"
                        )
                      }}
                    />
                  </Tooltip>
                  <Tooltip placement="topRight" title="Exportar divisiones">
                    <Button
                      className="whiteButton"
                      size="default"
                      icon={<DownloadOutlined />}
                      onClick={() => {
                        woopraTrack("Exportar divisiones")
                        this.props.getTemplateDivision(false)
                      }}
                    />
                  </Tooltip>
                </div>
            )}
          </div>
        </div>
        <div>
          <Table
            rowKey="index"
            onChange={handleTableChange}
            key={this.state.indexTable}
            rowSelection={this.props.rowSelection}
            dataSource={this.props.data}
            columns={columns}
            loading={this.props.isLoading || this.state.isLoadingState}
            className="asdf"
            pagination={{
              pageSizeOptions: ["15", "25", "50", "100"],
              showSizeChanger: true,
              size: "default",
              defaultPageSize: 15,
              showTotal: this.showTotal,
              current: this.props.current_page,
              pageSize: this.props.per_page,
              total: this.props.total,
              sorter: {}
            }}
          />
        </div>

        <ModalCustom
          showFooter
          title="Seleccionar división superior"
          textAlign="left"
          modalOpen={this.state.showModalSelectDivisionSuperior}
          width={390}
          onCancel={() => {
            this.setState({
              showModalSelectDivisionSuperior: false,
              idParentSelected: undefined,
            })
          }}
          disabledButton={!this.state.idParentSelected}
          onOk={() => {
            const params = {
              idDivision: this.state.divisionSuperiorSelected.id_division,
              idParent: this.state.idParentSelected,
            }
            this.props.selectDivisionSuperior(params)

            this.setState({
              showModalSelectDivisionSuperior: false,
              idParentSelected: undefined,
              mainSearchValue: "",
            })
          }}>
          <p>
            Selecciona la división que se encontrará por encima de
            <span style={{ fontWeight: 600 }}>
              {" "}
              {this.state.divisionSuperiorSelected.division &&
                this.state.divisionSuperiorSelected.division}{" "}
            </span>
            en el organigrama:
          </p>
          <Select
            style={{ width: 314 }}
            value={this.state.idParentSelected}
            onChange={(idParent) => {
              this.setState({ idParentSelected: idParent })
            }}
            showSearch
            placeholder="Seleccionar división superior"
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }>
            {Array.isArray(this.props.divisionParents) &&
              this.props.divisionParents.map((item) => {
                return (
                  <Select.Option
                    key={item.id_division}
                    value={item.id_division}>
                    {item.name}
                  </Select.Option>
                )
              })}
          </Select>
        </ModalCustom>
        <ModalCustom
          showOnlyCancel
          textCancelButton="Cerrar"
          modalOpen={this.state.modalSubdivisionSelected}
          margin="0"
          textAlign="left"
          title="Agregar subdivisiones"
          width={457}
          onCancel={() => {
            buttonAction_btns("Cerrar Agregar subdivisiones")
            this.setState({
              modalSubdivisionSelected: false,
              valueOptionSelected: undefined,
              orderBySubdivisions: true,
            })
          }}>
          <p style={{ fontSize: 13, color: "#555155" }}>
            Selecciona las subdivisiones que deseas agregar. Estas se
            encontrarán debajo de{" "}
            <span style={{ fontWeight: 600 }}>
              {get(this.state.subdivisionSelected, "division", "")}
            </span>{" "}
            en el organigrama de la organización.
          </p>
          <AddSubdivisionSelect
            isButtonDisabled={!this.state.valueOptionSelected}
            valueOptionSelected={this.state.valueOptionSelected}
            changeSelectOption={this.changeSelectOptionSubdivision}
            data={
              Array.isArray(this.props.divisionsUnassigned)
                ? this.props.divisionsUnassigned.filter((item) => {
                  return (
                    item.id_division !==
                    this.state.subdivisionSelected.id_division
                  )
                })
                : []
            }
            onAdd={() => {
              const params = {
                idDivision: this.state.subdivisionSelected.id_division,
                idSubdivision: this.state.valueOptionSelected,
              }
              this.props.addSubdivisionTable(params)
              this.setState({
                valueOptionSelected: undefined,
                mainSearchValue: "",
              })
            }}
          />
          <Divider className="separator" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 10,
            }}>
            <span
              style={{
                fontSize: 12,
                color: "rgba(130, 130, 130, 0.83)",
                marginBottom: 5,
              }}>
              {filter(
                get(this.props.subdivisionsTable, "data", []),
                (item) => !item.autoassigned
              ).length === 1
                ? "1 subdivisión"
                : `${filter(
                  get(this.props.subdivisionsTable, "data", []),
                  (item) => !item.autoassigned
                ).length
                } subdivisiones`}
            </span>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ fontWeight: 600, fontSize: 13, color: "#555155" }}>
                Subdivisiones
              </span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: 12,
                  cursor: "pointer",
                  userSelect: "none",
                }}
                onClick={() => {
                  this.changeSelectOptionSubdivision(
                    "orderBySubdivisions",
                    !this.state.orderBySubdivisions
                  )
                }}>
                <img
                  alt="arrow-bottom-select"
                  src={arrowBottomSelect}
                  style={{
                    transform: "rotate(180deg)",
                    margin: "0 0 3px 0",
                    width: 10,
                    paddingLeft: 1,
                  }}
                />
                <img
                  src={arrowBottomSelect}
                  style={{ width: 10 }}
                  alt="arrow-bottom-select"
                />
              </div>
            </div>
          </div>
          <ListSubdivisions
            onRemove={(subdivisionSelected) => {
              this.setState({ isRemovingSubdivision: true })
              const params = {
                idDivision: this.state.subdivisionSelected.id_division,
                idSubdivision: subdivisionSelected.id_division,
              }
              this.valueOfSelectAddSubdivision = params
              this.props.deleteSubdivisionTable(params)
              this.setState({ mainSearchValue: "" })
              this.showAlertDeleteSubdivision()
            }}
            loading={
              this.props.isLoadingSubdivisionsTable ||
              this.state.isRemovingSubdivision
            }
            data={filter(
              orderBy(
                get(this.props.subdivisionsTable, "data", []),
                ["name"],
                [this.state.orderBySubdivisions ? "asc" : "desc"]
              ),
              (item) => !item.autoassigned
            )}
          />
        </ModalCustom>
        <ModalCustom
          showFooter
          modalOpen={this.state.modalDeleteDivision}
          textButton="Eliminar"
          colorButton="#EA6364"
          onCancel={() => this.setState({ modalDeleteDivision: false })}
          onOk={() => {

            const params = {
              table: true, divisions: this.state.selectedDivisionItems,
              divisions_parent: this.state.selectedDivisionSuperiorItems,
              levels: this.state.levelSelecteds
            }

            this.props.deleteDivisionTable(
              this.state.divisionsSelected.id_division
            )
            this.setState({ modalDeleteDivision: false })
          }}>
          <img src={alertSvg} className="alertIcon" />
          {this.state.divisionsSelected &&
            this.state.divisionsSelected.employees.count ? (
            <p>
              No es posible eliminar una división con colaboradores asignados.
            </p>
          ) : (
            <React.Fragment>
              <p style={{ fontWeight: 600, fontSize: 14, marginBottom: '1em' }}>
                ¿Estás seguro de que deseas eliminar la división seleccionada?
              </p>
              <p style={{ fontWeight: 600, fontSize: 14, marginBottom: 0 }}>
                Se perderá la información de los embajadores asociados a esta.
              </p>
              <p style={{ fontSize: 13 }}>
                Asimismo, deberás asignarle una nueva división superior a las<br /> subdivisiones dentro.
              </p>
            </React.Fragment>
          )}
        </ModalCustom>
        {this.state.openCollaboratorsModal && (
          <CollaboratorsModal
            onOk={() => this.setState({ openCollaboratorsModal: false })}
            divisionName={get(this.state, "divisionsSelected.division", "")}
            data={get(this.props.collaboratorsTable, "data", [])}
            loading={this.props.isLoadingCollaboratorsTable}
            openModal={() => {
              this.state.openCollaboratorsModal
            }}
          />
        )}
      </div>
    )
  }
}

DivisionTable.propTypes = {
  isLoading: PropTypes.bool,
  getDivisions: PropTypes.func,
  createModal: PropTypes.bool,
  toggleCreateModal: PropTypes.func,
  data: PropTypes.array,
}

export default withRouter(DivisionTable)
